import type { FieldConfig, OperationOption, ValueState } from '../../types'

import { intlFormat } from '@/shared/tools/dates'

import { Operators } from '../../constants'
import FieldController from '../Controller'

export default class DateController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.getFilterTypes = config.getFilterTypes || this.getFilterTypes
		this.placeholder = config.placeholder || this.placeholder
	}
	placeholder = '__/__/____'

	hasValue = ({ value }: ValueState) =>
		Array.isArray(value) ? value.length > 0 : !!value

	getInitialValue = () => ({
		operation: Operators.DATE_AT,
		value: undefined,
	})

	getFilterTypes = (): OperationOption[] => [
		{ operation: Operators.DATE_AFTER, label: 'after', hasInput: true },
		{ operation: Operators.DATE_AT, label: 'at', hasInput: true },
		{ operation: Operators.DATE_BEFORE, label: 'before', hasInput: true },
		{ operation: Operators.DATE_BETWEEN, label: 'between', hasInput: true },
		{ operation: Operators.IS_EMPTY, label: 'has no value' },
		{ operation: Operators.IS_NOT_EMPTY, label: 'has value' },
	]
	formatState = ({ value, operation }: ValueState) => {
		if (operation === Operators.DATE_BETWEEN) {
			return `${value?.[0] ? intlFormat(new Date(value[0])) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1])) : this.placeholder}`
		}

		return {
			operation,
			value: value ? intlFormat(new Date(value as string)) : this.placeholder,
		}
	}
	formatLabel = ({ value, operation }: ValueState) => {
		if (operation === Operators.DATE_BETWEEN) {
			return `${value?.[0] ? intlFormat(new Date(value?.[0])) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1])) : this.placeholder}`
		}

		return value ? intlFormat(new Date(value as string)) : this.placeholder
	}
}
